/**
 * Big Dutchman Theme for Highcharts JS
 * @author Michael Bornhorst
 */

Highcharts.setOptions({
    tooltip:{
        enabled:false
    },
    lang: {
        decimalPoint: ',',
        thousandsSep: '.',
        downloadPNG: 'PNG erzeugen',
        downloadJPEG: 'JPG erzeugen',
        downloadPDF: 'PDF erzeugen',
        downloadSVG: 'SVG erzeugen',
        printChart: 'Drucken'
    },
    exporting: {
        chartOptions: {
            chart: {
                margin: 100
            },
            xAxis:{
                labels:{
                    style:{
                        fontFamily: 'sans-serif'
                    }
                }
            },
            yAxis:{
                labels:{
                    style:{
                        fontFamily: 'sans-serif'
                    }
                }
            },
            labels:{
                style:{
                    fontFamily: 'sans-serif'
                }
            },
            legend:{
                itemDistance: 50
            },
            plotOptions: {
                series: {
                    dataLabels: {
                        enabled: true,
                        style:{
                            fontFamily: 'sans-serif'
                        }
                    }
                }
            }
        }
    }
});

Highcharts.theme = {
    colors: ["#EA6F18", "#D16618", "#F7781C", "#AA5313", "#6A340C"],
    title: {
        text: null
    },
    subtitle: {
        style: {
            color: '#848484',
            font: '10px "UniversLTW02-47LightCn", "UniversLTW10-47LightCn"'
        }
    },
    xAxis: {
        gridLineWidth: 0,
        lineColor: '#848484',
        tickColor: '#848484',
        labels: {
            style: {
                color: '#848484',
                font: '16px "UniversLTW02-47LightCn", "UniversLTW10-47LightCn"',
                textShadow: false
            },
            y: 20
        },
        title: {
            style: {
                color: '#848484',
                font: '8px "UniversLTW02-47LightCn", "UniversLTW10-47LightCn"',
                textShadow: false
            }
        }
    },
    yAxis: {
        alternateGridColor: null,
        minorTickInterval: null,
        lineColor: '#848484',
        tickColor: '#848484',
        gridLineColor: '#848484',
        minorGridLineColor: '#848484',
        lineWidth: 1,
        tickWidth: 1,
        labels: {
            style: {
                color: '#848484',
                font: '16px "UniversLTW02-47LightCn", "UniversLTW10-47LightCn"',
                textShadow: false
            },
            y: 10
        },
        title: {
            text: null
        }
    },
    legend: {
        enabled: false
    },
    labels: {
        style: {
            color: '#848484',
            font: '15px "UniversLTW02-47LightCn", "UniversLTW10-47LightCn"',
            textShadow: false
        }
    },
    tooltip: {
        backgroundColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
                [0, 'rgba(96, 96, 96, .8)'],
                [1, 'rgba(16, 16, 16, .8)']
            ]
        },
        borderWidth: 0,
        style: {
            color: '#FFF'
        }
    },
    plotOptions: {
        series: {
            enabled: true,
            shadow: true,
            dataLabels: {
                style: {
                    color: '#848484',
                    font: '15px "UniversLTW02-47LightCn", "UniversLTW10-47LightCn"',
                    textShadow: false
                }
            }
        },
        column: {
            dataLabels: {
                enabled: true,
                style: {
                    color: '#848484',
                    fontSize: '15px',
                    textShadow: false
                }
            }
        },
        line: {
            dataLabels: {
                color: '#CCC'
            },
            marker: {
                lineColor: '#848484'
            }
        },
        spline: {
            marker: {
                lineColor: '#848484'
            }
        },
        scatter: {
            marker: {
                lineColor: '#848484'
            }
        },
        candlestick: {
            lineColor: 'white'
        }
    },

    toolbar: {
        itemStyle: {
            color: '#CCC'
        }
    },

    navigation: {
        buttonOptions: {
            symbolStroke: '#333',
            hoverSymbolStroke: '#FFFFFF',
            theme: {
                fill: '#fff',
                states: {
                    hover: {
                        symbolStroke: '#fff',
                        stroke: '#fff',
                        fill: '#EA6F18'
                    },
                    select: {
                        stroke: '#fff',
                        fill: '#EA6F18'
                    }
                }
            }
        },
        menuItemHoverStyle: {
            background: '#EA6F18',
            color: '#FFFFFF'
        }
    },

    // scroll charts
    rangeSelector: {
        buttonTheme: {
            fill: {
                linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                stops: [
                    [0.4, '#888'],
                    [0.6, '#555']
                ]
            },
            stroke: '#000000',
            style: {
                color: '#CCC',
                fontWeight: 'bold'
            },
            states: {
                hover: {
                    fill: {
                        linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                        stops: [
                            [0.4, '#BBB'],
                            [0.6, '#888']
                        ]
                    },
                    stroke: '#000000',
                    style: {
                        color: 'white'
                    }
                },
                select: {
                    fill: {
                        linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                        stops: [
                            [0.1, '#000'],
                            [0.3, '#848484']
                        ]
                    },
                    stroke: '#000000',
                    style: {
                        color: 'yellow'
                    }
                }
            }
        },
        inputStyle: {
            backgroundColor: '#848484',
            color: 'silver'
        },
        labelStyle: {
            color: 'silver'
        }
    },
    navigator: {
        handles: {
            backgroundColor: '#666',
            borderColor: '#AAA'
        },
        outlineColor: '#CCC',
        maskFill: 'rgba(16, 16, 16, 0.5)',
        series: {
            color: '#7798BF',
            lineColor: '#A6C7ED'
        }
    },
    scrollbar: {
        barBackgroundColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
                [0.4, '#888'],
                [0.6, '#555']
            ]
        },
        barBorderColor: '#CCC',
        buttonArrowColor: '#CCC',
        buttonBackgroundColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
                [0.4, '#888'],
                [0.6, '#555']
            ]
        },
        buttonBorderColor: '#CCC',
        rifleColor: '#FFF',
        trackBackgroundColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
                [0, '#000'],
                [1, '#848484']
            ]
        },
        trackBorderColor: '#666'
    },

    // special colors for some of the demo examples
    legendBackgroundColor: 'rgba(48, 48, 48, 0.8)',
    legendBackgroundColorSolid: 'rgb(10, 10, 10)',
    dataLabelsColor: '#444',
    textColor: '#E0E0E0',
    maskColor: 'rgba(255,255,255,0.3)'
};

// Apply the theme
var highchartsOptions = Highcharts.setOptions(Highcharts.theme);

$(function () {
    if($('#chart-one').length > 0) {
        $('#chart-one').highcharts({
            chart: {
                type: "column"
            },
            xAxis: {
                categories: ['2009', '2010', '2011', '2012', '2013', '2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025']
            },
            yAxis: {
                min: 0,
                max: 1750,
            },
            series: [{
                data: [462, 631, 850, 858, 732, 688, 791, 905, 895, 959, 986, 985, 985, 1123, 1067, 1039, 1522]
            }],
            exporting: {
                filename: 'Umsatz der Big Dutchman Gruppe (Mio.€)',
                sourceWidth: 1920,
                sourceHeight: 1080,
                chartOptions: {
                    title: {
                        text: 'Umsatz der Big Dutchman Gruppe (Mio.€)'
                    }
                }
            }
        });
    }

    if($('#chart-two').length > 0) {
        $('#chart-two').highcharts({
            chart: {
                type: 'column'
            },
            xAxis: {
                categories: ['2009', '2010', '2011', '2012', '2013', '2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025']
            },
            yAxis: {
                min: 0,
            },
            series: [{
                data: [1490, 1708, 2068, 2432, 2550, 2648, 2698, 2853, 3268, 3472, 3582, 3452, 3380, 3260, 3211, 3175, 3460]
            }],
            exporting: {
                filename: 'Mitarbeiterzahl der Big Dutchman Gruppe',
                sourceWidth: 1920,
                sourceHeight: 1080,
                chartOptions: {
                    title: {
                        text: 'Mitarbeiterzahl der Big Dutchman Gruppe'
                    }
                }
            }
        });
    }

});
